/** @format */

import React from "react";
import "./style.scss";
import { Link } from "react-router-dom";
import TransParentui from "../SvgIcons/TransParentui";

export default function TandemTimeline() {
  return (
    <section className='TandemTimeline' data-aos='fade-in'>
      <div className='container'>
        <div className='TandemTimeline-boxmain'>
          <div className='TandemTimelineLeftside'>
            <div className='BgShape'>
              <img
                src='../images/BgShape.svg'
                alt='BgShape'
                className='img-fluid'
              />
            </div>
            <div className='phonepicturebox'>
              <img
                src='../images/timeline_picture.png'
                alt='hero'
                className='img-fluid'
              />
              <div className='memoriestime'>
                <span>Super-fast</span> Access
                <br /> to Memories
              </div>
            </div>
            <div className='sapeinbox'>
              <TransParentui />
            </div>
          </div>
          <div className='TandemTimelineRightside'>
            <h3>Tandem Timeline™</h3>
            <h4>Gain super-fast access to your memories</h4>
            <p>
              Quickly gain a 30,000-foot view of your life online. Tandem
              Timeline™ feature allows users to compare their timeline with a
              friend’s, offering simple pinch-to-zoom functionality. This gives
              you the ability to shift from viewing years to specific times of
              the day in just seconds. Endless scrolling to find old posts is
              now a thing of the past.
            </p>
            <div className='playstore'>
              <Link
                to='https://apps.apple.com/us/app/paths-friends-memories-life/id1480890359'
                target='_blank'
              >
                <img
                  src='../images/android.png'
                  alt='android'
                  className='img-fluid'
                />
              </Link>
              <Link
                to='https://play.google.com/store/apps/details?id=com.getpaths.paths'
                target='_blank'
              >
                <img
                  src='../images/googlepaly.png'
                  alt='googlepaly'
                  className='img-fluid'
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
